package app.bloomey.web.core.offCanvas

import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.staticCompositionLocalOf


val LocalOffCanvasController = staticCompositionLocalOf {
    OffCanvasController()
}

class OffCanvasController {

    val items = mutableStateListOf<OffCanvasItem>()
    fun push(item: OffCanvasItem) {
        items.add(item)
    }

    fun pop() {
        items.removeLast()
    }

    fun pop(item:OffCanvasItem) {
        items.remove(item)
    }

    fun clear() {
        items.clear()
    }
}